import { css } from 'glamor';

// make css rules
const marquee = css({
  backgroundColor: '#040404',
  width: '100%',
  height: 'calc(100vh - 150px)',
});

const logoWrapper = css({
  display: 'flex',
  width: '10rem',
  height: '100%',
  alignItems: 'center',
  justifyContent: 'middle',
  position: 'absolute',
  top: 0,
  left: 'calc(50% - 5rem)',
  margin: '0 auto',
  zIndex: 1,
  transition: 'opacity 0.3s',
  pointerEvents: 'none',
});

const logoRule = css({
  flex: 0,
  width: '100%%',
  height: 'auto',
});

const containerRule = css({
  height: 'calc(100vh - 150px)',
  // opacity: 0,
  // transition: 'opacity 0.3s',
});

export { marquee, logoWrapper, logoRule, containerRule };



// WEBPACK FOOTER //
// ./src/components/Marquee/styles.js